import { Vec3, _decorator } from 'cc';

const { ccclass, property } = _decorator;

@ccclass('HSL')
export default class HSL {
    @property
    private _hsl: Vec3 = Vec3.ZERO.clone();

    @property({ min: -180, max: 180, step: 1, slide: true })
    public set hue(value: number) {
        if (this._hsl.x === value) {
            return;
        }
        this._hsl.x = value;
    }
    public get hue() {
        return this._hsl.x;
    }

    @property({ min: -100, max: 100, step: 1, slide: true })
    public get saturation(): number {
        return this._hsl.y;
    }
    public set saturation(value: number) {
        if (this._hsl.y === value) {
            return;
        }
        this._hsl.y = value;
    }

    @property({ min: -100, max: 100, step: 1, slide: true })
    public get lightness(): number {
        return this._hsl.z;
    }
    public set lightness(value: number) {
        if (this._hsl.z === value) {
            return;
        }
        this._hsl.z = value;
    }

    public get hsl(): Readonly<Vec3> {
        return this._hsl;
    }
    public set hsl(value: Vec3) {
        if (this._hsl.equals(value)) {
            return;
        }
        this._hsl.set(value);
    }
}
